(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9748],{

/***/ 63205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), 'AddCircle');
exports.Z = _default;

/***/ }),

/***/ 86885:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M7 6h10l-5.01 6.3L7 6zm-2.75-.39C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAltOutlined');
exports.Z = _default;

/***/ }),

/***/ 6714:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), 'RemoveRedEye');
exports.Z = _default;

/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 92120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ useAccountAddress; }
});

// EXTERNAL MODULE: ./node_modules/@saleor/sdk/dist/sdk.esm.js + 1 modules
var sdk_esm = __webpack_require__(21637);
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(10928);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
// EXTERNAL MODULE: ./saleor/api.tsx + 2 modules
var api = __webpack_require__(39259);
;// CONCATENATED MODULE: ./components/account/hooks/useAccountAddress.ts



var useAccountAddress = function useAccountAddress() {
  var fetchPolicy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cache-first";

  var _useAuthState = (0,sdk_esm/* useAuthState */.F_)(),
      authenticated = _useAuthState.authenticated;

  var _useCurrentUserAddres = (0,api/* useCurrentUserAddressesQuery */.Mcz)({
    skip: !authenticated || false,
    fetchPolicy: fetchPolicy
  }),
      data = _useCurrentUserAddres.data,
      loading = _useCurrentUserAddres.loading;

  var getAddress = function getAddress(type, strict) {
    var _data$me3;

    if (type) {
      var _data$me, _data$me$addresses;

      var address = (data === null || data === void 0 ? void 0 : (_data$me = data.me) === null || _data$me === void 0 ? void 0 : (_data$me$addresses = _data$me.addresses) === null || _data$me$addresses === void 0 ? void 0 : _data$me$addresses.find(function (add) {
        return type === api/* AddressTypeEnum.Billing */.m3h.Billing && (add === null || add === void 0 ? void 0 : add.isDefaultBillingAddress) || type === api/* AddressTypeEnum.Shipping */.m3h.Shipping && (add === null || add === void 0 ? void 0 : add.isDefaultShippingAddress);
      })) || undefined;

      if (!address && !strict) {
        var _data$me2;

        return last_default()(data === null || data === void 0 ? void 0 : (_data$me2 = data.me) === null || _data$me2 === void 0 ? void 0 : _data$me2.addresses) || undefined;
      }

      return address;
    }

    return last_default()(data === null || data === void 0 ? void 0 : (_data$me3 = data.me) === null || _data$me3 === void 0 ? void 0 : _data$me3.addresses) || undefined;
  };

  return [getAddress, loading];
};
/* harmony default export */ var hooks_useAccountAddress = ((/* unused pure expression or super */ null && (useAccountAddress)));
;// CONCATENATED MODULE: ./components/account/index.ts


/***/ }),

/***/ 40713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17674);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14744);
/* harmony import */ var _mui_icons_material_RemoveRedEye__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6714);
/* harmony import */ var _mui_material_Alert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46901);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11057);
/* harmony import */ var _saleor_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89211);
/* harmony import */ var _saleor_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39259);
/* harmony import */ var _shared_contexts_ChannelContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59247);
/* harmony import */ var _SelectedClientsDialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64587);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);















var CheckoutClientBanner = function CheckoutClientBanner(_ref) {
  var _data$userDraftChecko, _data$userDraftChecko2;

  var onClose = _ref.onClose,
      selectedVariant = _ref.selectedVariant;

  var _useAuthState = (0,_saleor_sdk__WEBPACK_IMPORTED_MODULE_1__/* .useAuthState */ .F_)(),
      authenticated = _useAuthState.authenticated;

  var _useChannelContext = (0,_shared_contexts_ChannelContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      channel = _useChannelContext.channel;

  var _useUserDraftCheckout = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_3__/* .useUserDraftCheckoutsQuery */ .Pr_)({
    variables: {
      first: 100,
      channel: channel,
      multipleCheckout: false
    },
    skip: !authenticated,
    fetchPolicy: "network-only"
  }),
      data = _useUserDraftCheckout.data;

  var _useToggle = (0,react_use__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(false),
      _useToggle2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_useToggle, 2),
      isOpen = _useToggle2[0],
      toggleOpen = _useToggle2[1];

  if (!authenticated || !(data !== null && data !== void 0 && data.userDraftCheckouts)) {
    return null;
  }

  var checkouts = (data === null || data === void 0 ? void 0 : (_data$userDraftChecko = data.userDraftCheckouts) === null || _data$userDraftChecko === void 0 ? void 0 : (_data$userDraftChecko2 = _data$userDraftChecko.edges) === null || _data$userDraftChecko2 === void 0 ? void 0 : _data$userDraftChecko2.map(function (edge) {
    return edge.node;
  })) || [];
  var clients = checkouts.map(function (c) {
    return c.profile;
  }).filter(function (n) {
    return !!n;
  });

  if (clients.length === 0) {
    return null;
  }

  var closeDialog = function closeDialog() {
    onClose && onClose();
    toggleOpen();
  };

  var synClients = clients.filter(function (c) {
    return !!c;
  }).map(function (profile) {
    var res = {
      id: profile.id,
      person: profile,
      isJointPlanning: false,
      gmClientId: 0
    };
    return res;
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material_Alert__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      severity: "info",
      action: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        onClick: toggleOpen,
        startIcon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_icons_material_RemoveRedEye__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}),
        className: "capitalize",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_0__/* .Trans */ .cC, {
          id: "Add Recipients"
        })
      }),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_0__/* .Trans */ .cC, {
        id: "{0, plural, one {Shopping for # Recipient} other {Shopping for # Recipients}}",
        values: {
          "0": (clients === null || clients === void 0 ? void 0 : clients.length) || 0
        }
      })
    }), clients && (clients === null || clients === void 0 ? void 0 : clients.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_SelectedClientsDialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      isOpen: isOpen,
      onClose: closeDialog,
      clients: synClients,
      onShopForClients: toggleOpen,
      selectedVariant: selectedVariant
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CheckoutClientBanner);

/***/ }),

/***/ 44165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ contactSchema; }
/* harmony export */ });
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(98456);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(51233);
/* harmony import */ var _mui_material_Divider__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67720);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14744);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32601);
/* harmony import */ var yup_phone__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48269);
/* harmony import */ var yup_phone__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(yup_phone__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11057);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7258);
/* harmony import */ var _components_shared_fields__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93442);
/* harmony import */ var _components_shared_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9335);
/* harmony import */ var _lib_util__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4829);
/* harmony import */ var _saleor_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39259);
/* harmony import */ var _shared_fields_DateField__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86908);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);
















 // import { GENDERS } from "./ClientFilterDialog";



var CountryField = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.lazy(function () {
  return __webpack_require__.e(/* import() */ 7845).then(__webpack_require__.bind(__webpack_require__, 67845));
});
var contactSchema = yup__WEBPACK_IMPORTED_MODULE_6__.object({
  email: yup__WEBPACK_IMPORTED_MODULE_6__.string().email().label(
  /*i18n*/
  _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Email")),
  firstName: yup__WEBPACK_IMPORTED_MODULE_6__.string().label(
  /*i18n*/
  _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("First Name")).required(),
  lastName: yup__WEBPACK_IMPORTED_MODULE_6__.string().label(
  /*i18n*/
  _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Last Name")).notRequired(),
  dateOfBirth: yup__WEBPACK_IMPORTED_MODULE_6__.date().notRequired().nullable(),
  gender: yup__WEBPACK_IMPORTED_MODULE_6__.string().oneOf([null, "MALE", "FEMALE"]).nullable().notRequired(),
  address: yup__WEBPACK_IMPORTED_MODULE_6__.object({
    phone: yup__WEBPACK_IMPORTED_MODULE_6__.string().label(
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Phone")).phone("SG", true).required(),
    streetAddress1: yup__WEBPACK_IMPORTED_MODULE_6__.string().label(
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Street Address 1")).required(),
    streetAddress2: yup__WEBPACK_IMPORTED_MODULE_6__.string().label(
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Street Address 2")).notRequired(),
    city: yup__WEBPACK_IMPORTED_MODULE_6__.string().label(
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("City")).required(),
    country: yup__WEBPACK_IMPORTED_MODULE_6__.mixed().label(
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Country")).required(),
    postalCode: yup__WEBPACK_IMPORTED_MODULE_6__.string().label(
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Postal Code")).required(),
    unitNumber: yup__WEBPACK_IMPORTED_MODULE_6__.string().label(
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Unit No")).notRequired()
  }).required()
}).required(); // export type Contact = yup.InferType<typeof contactSchema>;

var ContactForm = function ContactForm(_ref) {
  var onCompleted = _ref.onCompleted,
      onCancel = _ref.onCancel,
      existingData = _ref.existingData,
      updateMutation = _ref.updateMutation,
      _ref$emailEditable = _ref.emailEditable,
      emailEditable = _ref$emailEditable === void 0 ? true : _ref$emailEditable;
  var GENDERS = [{
    value: "MALE",
    label:
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Male")
  }, {
    value: "FEMALE",
    label:
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Female")
  }];

  var _useSnackbar = (0,_components_shared_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useSnackbar */ .D)(),
      showSnackbar = _useSnackbar.showSnackbar;

  var initialValues = react__WEBPACK_IMPORTED_MODULE_5__.useMemo(function () {
    return existingData || {
      email: "",
      firstName: "",
      lastName: "",
      dateOfBirth: undefined,
      gender: "",
      address: {
        phone: "",
        firstName: "",
        lastName: "",
        streetAddress1: "",
        streetAddress2: "",
        country: _saleor_api__WEBPACK_IMPORTED_MODULE_9__/* .CountryCode.Sg */ .CvE.Sg,
        city: "",
        postalCode: "",
        unitNumber: ""
      }
    };
  }, [existingData]);

  var handleSubmitForm = /*#__PURE__*/function () {
    var _ref2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values, helpers) {
      var errors, message;
      return _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              helpers.setSubmitting(true);
              _context.next = 3;
              return updateMutation(values);

            case 3:
              errors = _context.sent;
              helpers.setSubmitting(false);

              if (errors.length === 0) {
                onCompleted && onCompleted();
              } else {
                errors.forEach(function (e) {
                  var fieldName = e.field || "";

                  if (["streetAddress1", "streetAddress2", "phone", "unitNumber", "country", "city", "postalCode", "dateOfBirth", "gender"].includes(fieldName)) {
                    fieldName = "address.".concat(fieldName);
                  }

                  fieldName && helpers.setFieldError(fieldName, e.message ||
                  /*i18n*/
                  _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("This field is required."));
                });
                message = errors.map(function (c) {
                  return c.message;
                }).filter(_lib_util__WEBPACK_IMPORTED_MODULE_13__/* .notNullable */ .Yj).join("\n") ||
                /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("There was an error creating contact! Please try again");
                showSnackbar({
                  message: message,
                  severity: "error",
                  horizontal: "center"
                });
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmitForm(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderForm = function renderForm(_ref3) {
    var isSubmitting = _ref3.isSubmitting,
        values = _ref3.values,
        setFieldValue = _ref3.setFieldValue;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        direction: "column",
        spacing: 3,
        divider: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material_Divider__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          orientation: "horizontal"
        }),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          direction: "column",
          spacing: 1.5,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 2,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .InputField */ .UP, {
              name: "firstName",
              label:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("First Name"),
              required: true
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .InputField */ .UP, {
              name: "lastName",
              label:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Last Name")
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 2,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .InputField */ .UP, {
              name: "email",
              label:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Email"),
              type: "email",
              disabled: !emailEditable
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .InputField */ .UP, {
              name: "address.phone",
              label:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Phone"),
              type: "tel",
              required: true
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 2,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
              name: "dateOfBirth",
              component: _shared_fields_DateField__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
              value: values.dateOfBirth,
              label:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Date of Birth"),
              momentFormat: "DD-MM-YYYY",
              onChange: function onChange(value) {
                setFieldValue("dateOfBirth", value);
              },
              disablePast: false,
              disableFuture: true,
              disableInput: true
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .DropdownField */ .Hi, {
              label:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Gender"),
              data: GENDERS,
              name: "gender",
              defaultText:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Select...")
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 2
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .InputField */ .UP, {
            name: "address.streetAddress1",
            label:
            /*i18n*/
            _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Street Address 1"),
            required: true
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .InputField */ .UP, {
            name: "address.streetAddress2",
            label:
            /*i18n*/
            _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Street Address 2")
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 2,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .InputField */ .UP, {
              name: "address.unitNumber",
              label:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Unit No")
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react__WEBPACK_IMPORTED_MODULE_5__.Suspense, {
              fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {}),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(CountryField, {
                name: "address.country",
                label:
                /*i18n*/
                _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Country"),
                required: true,
                disabled: true
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 2,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .InputField */ .UP, {
              name: "address.city",
              label:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("City"),
              required: true
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_shared_fields__WEBPACK_IMPORTED_MODULE_7__/* .InputField */ .UP, {
              name: "address.postalCode",
              label:
              /*i18n*/
              _lingui_core__WEBPACK_IMPORTED_MODULE_2__/* .i18n._ */ .ag._("Postal Code"),
              required: true,
              type: "text"
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          spacing: 2,
          direction: "row",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            variant: "outlined",
            fullWidth: true,
            onClick: onCancel,
            disabled: isSubmitting,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
              id: "Cancel"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            type: "submit",
            variant: "contained",
            fullWidth: true,
            disabled: isSubmitting,
            endIcon: isSubmitting && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              size: 20
            }),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
              id: "Save"
            })
          })]
        })]
      })
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Formik */ .J9, {
    initialValues: initialValues,
    onSubmit: handleSubmitForm,
    validationSchema: contactSchema,
    children: renderForm
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ContactForm);

/***/ }),

/***/ 37566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_material_Container__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(65582);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11057);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17674);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14744);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32601);
/* harmony import */ var _mui_icons_material_AddCircleOutline__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41687);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89211);
/* harmony import */ var _components_shared_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9335);
/* harmony import */ var _lib_util__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4829);
/* harmony import */ var _saleor_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39259);
/* harmony import */ var _shared_dialog_GenericDialog__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54166);
/* harmony import */ var _ContactForm__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44165);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var CreateContactButton = function CreateContactButton(_ref) {
  var onCompleted = _ref.onCompleted;

  var _useClientCreateMutat = (0,_saleor_api__WEBPACK_IMPORTED_MODULE_7__/* .useClientCreateMutation */ .X3f)(),
      _useClientCreateMutat2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useClientCreateMutat, 1),
      clientCreate = _useClientCreateMutat2[0];

  var _useSnackbar = (0,_components_shared_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useSnackbar */ .D)(),
      showSnackbar = _useSnackbar.showSnackbar;

  var _useToggle = (0,react_use__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(false),
      _useToggle2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useToggle, 2),
      dialogOpen = _useToggle2[0],
      toggleDialog = _useToggle2[1];

  var handleCompleted = function handleCompleted() {
    toggleDialog();
    onCompleted && onCompleted();
    showSnackbar({
      message:
      /*i18n*/
      _lingui_core__WEBPACK_IMPORTED_MODULE_3__/* .i18n._ */ .ag._("New contact has been created successfully!"),
      severity: "success"
    });
  };

  var performMutation = /*#__PURE__*/function () {
    var _ref2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
      var _data$clientCreate;

      var _yield$clientCreate, data;

      return _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return clientCreate({
                variables: {
                  client: {
                    firstName: values.firstName,
                    lastName: values.lastName,
                    email: values.email,
                    dateOfBirth: values.dateOfBirth ? moment__WEBPACK_IMPORTED_MODULE_4___default()(values.dateOfBirth).format("YYYY-MM-DD") : null,
                    defaultShippingAddress: _objectSpread(_objectSpread({}, values.address), {}, {
                      firstName: values.firstName,
                      lastName: values.lastName
                    })
                  }
                }
              });

            case 2:
              _yield$clientCreate = _context.sent;
              data = _yield$clientCreate.data;
              return _context.abrupt("return", (data === null || data === void 0 ? void 0 : (_data$clientCreate = data.clientCreate) === null || _data$clientCreate === void 0 ? void 0 : _data$clientCreate.errors.filter(_lib_util__WEBPACK_IMPORTED_MODULE_14__/* .notNullable */ .Yj)) || []);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function performMutation(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
      variant: "contained",
      color: "primary",
      className: "capitalize",
      startIcon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_icons_material_AddCircleOutline__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {}),
      onClick: toggleDialog,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
        id: "Create Contact"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_shared_dialog_GenericDialog__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      isOpen: dialogOpen,
      onClose: toggleDialog,
      fullWidth: true,
      title:
      /*i18n*/
      _lingui_core__WEBPACK_IMPORTED_MODULE_3__/* .i18n._ */ .ag._("Create new Contact"),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material_Container__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        maxWidth: "lg",
        className: "pb-3",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ContactForm__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          onCompleted: handleCompleted,
          onCancel: toggleDialog,
          updateMutation: performMutation
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CreateContactButton);

/***/ }),

/***/ 6494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ contacts_SelectClientDialog; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@lingui/react/build/esm/index.js
var esm = __webpack_require__(14744);
// EXTERNAL MODULE: ./node_modules/@lingui/core/build/esm/index.js + 1 modules
var build_esm = __webpack_require__(32601);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(42761);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@saleor/sdk/dist/sdk.esm.js + 1 modules
var sdk_esm = __webpack_require__(21637);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./saleor/api.tsx + 2 modules
var api = __webpack_require__(39259);
// EXTERNAL MODULE: ./components/personalize/utils.ts
var utils = __webpack_require__(16825);
// EXTERNAL MODULE: ./components/shared/contexts/ChannelContext.tsx + 2 modules
var ChannelContext = __webpack_require__(59247);
// EXTERNAL MODULE: ./components/shared/dialog/GenericDialog.tsx
var GenericDialog = __webpack_require__(54166);
// EXTERNAL MODULE: ./components/utils/address.ts
var address = __webpack_require__(76413);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FilterAltOutlined.js
var FilterAltOutlined = __webpack_require__(86885);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(48403);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
// EXTERNAL MODULE: ./components/shared/fields/index.tsx + 4 modules
var fields = __webpack_require__(93442);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/contacts/ClientFilterDialog.tsx





var _excluded = ["filters", "applyFilter"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var GENDERS = (/* unused pure expression or super */ null && ([]));
var MARITAL_STATUSES = ["MARRIED", "SINGLE", "DIVORCED", "SEPARATED", "WIDOWED"];
var BIRTH_DAYS = [{
  value: "ALL",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("All")
}, {
  value: "THIS_WEEK",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("This Week")
}, {
  value: "NEXT_WEEK",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Next Week")
}, {
  value: "THIS_MONTH",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("This Month")
}, {
  value: "NEXT_MONTH",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Next Month")
}, {
  value: "THREE_MONTHS",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Next Three Months")
}];

var ClientFilterDialog = function ClientFilterDialog(_ref) {
  var filters = _ref.filters,
      applyFilter = _ref.applyFilter,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var handleSubmit = function handleSubmit(values) {
    applyFilter(values);
  };

  var handleReset = function handleReset() {
    applyFilter(null);
  };

  var GENDERS = [{
    value: "MALE",
    label:
    /*i18n*/
    build_esm/* i18n._ */.ag._("Male")
  }, {
    value: "FEMALE",
    label:
    /*i18n*/
    build_esm/* i18n._ */.ag._("Female")
  }];
  var MRS = MARITAL_STATUSES.map(function (v) {
    return {
      label:
      /*i18n*/
      build_esm/* i18n._ */.ag._("{0}", {
        "0": capitalize_default()(v)
      }),
      value: v
    };
  });
  var BD = BIRTH_DAYS.map(function (v) {
    return {
      label: v.label,
      value: v.value
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GenericDialog/* default */.Z, _objectSpread(_objectSpread({}, others), {}, {
    maxWidth: "md",
    title:
    /*i18n*/
    build_esm/* i18n._ */.ag._("Select Recipients to Shop for"),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      width: "100%",
      px: 2,
      pb: 2,
      pt: 1,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: _objectSpread({
          gender: ["MALE", "FEMALE"],
          maritalStatus: "",
          birthday: "ALL",
          startAge: 0,
          endAge: 99,
          residency: "",
          nationality: "",
          goals: "",
          tags: ""
        }, filters),
        onSubmit: handleSubmit,
        children: function children(_ref2) {
          var submitForm = _ref2.submitForm;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
              container: true,
              spacing: 2,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                  direction: "row",
                  spacing: 2,
                  justifyContent: "flex-end",
                  divider: /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    orientation: "vertical",
                    className: "my-1",
                    flexItem: true
                  }),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: handleReset,
                    size: "small",
                    children:
                    /*i18n*/
                    build_esm/* i18n._ */.ag._("Clear")
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: submitForm,
                    color: "primary",
                    variant: "contained",
                    size: "small",
                    children:
                    /*i18n*/
                    build_esm/* i18n._ */.ag._("Apply Filter")
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(fields/* CheckboxGroupField */.cs, {
                  label:
                  /*i18n*/
                  build_esm/* i18n._ */.ag._("Gender"),
                  name: "gender",
                  data: GENDERS
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 6,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(fields/* DropdownField */.Hi, {
                  label:
                  /*i18n*/
                  build_esm/* i18n._ */.ag._("Marital Status"),
                  data: MRS,
                  name: "maritalStatus",
                  defaultText:
                  /*i18n*/
                  build_esm/* i18n._ */.ag._("Select...")
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 6,
                md: 3,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(fields/* InputField */.UP, {
                  label:
                  /*i18n*/
                  build_esm/* i18n._ */.ag._("Start Age"),
                  name: "startAge",
                  type: "number"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 6,
                md: 3,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(fields/* InputField */.UP, {
                  label:
                  /*i18n*/
                  build_esm/* i18n._ */.ag._("End Age"),
                  name: "endAge",
                  type: "number"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 6,
                md: 3,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(fields/* DropdownField */.Hi, {
                  label:
                  /*i18n*/
                  build_esm/* i18n._ */.ag._("Birthday"),
                  data: BD,
                  name: "birthday"
                })
              })]
            })
          });
        }
      })
    })
  }));
};

/* harmony default export */ var contacts_ClientFilterDialog = (ClientFilterDialog);
;// CONCATENATED MODULE: ./components/contacts/ClientFilterButton.tsx











var ClientFilterButton = function ClientFilterButton(_ref) {
  var onFilterChanged = _ref.onFilterChanged;

  var _useToggle = (0,useToggle/* default */.Z)(false),
      _useToggle2 = (0,slicedToArray/* default */.Z)(_useToggle, 2),
      isOpen = _useToggle2[0],
      toggleOpen = _useToggle2[1];

  var _useState = (0,react.useState)(null),
      filter = _useState[0],
      setFilter = _useState[1];

  var applyFilter = function applyFilter(newValue) {
    setFilter(newValue);
    onFilterChanged(newValue);
    toggleOpen();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      color: "primary",
      startIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(FilterAltOutlined/* default */.Z, {}),
      onClick: toggleOpen,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
        id: "Filter List"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(contacts_ClientFilterDialog, {
      isOpen: isOpen,
      onClose: toggleOpen,
      filters: filter,
      applyFilter: applyFilter
    })]
  });
};

/* harmony default export */ var contacts_ClientFilterButton = (ClientFilterButton);
// EXTERNAL MODULE: ./components/contacts/CreateContactButton.tsx
var CreateContactButton = __webpack_require__(37566);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/ArrowDownward.js



/**
 * @ignore - internal component.
 */

/* harmony default export */ var ArrowDownward = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward'));
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var utils_capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableSortLabel/tableSortLabelClasses.js


function getTableSortLabelUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTableSortLabel', slot);
}
const tableSortLabelClasses = (0,generateUtilityClasses/* default */.Z)('MuiTableSortLabel', ['root', 'active', 'icon', 'iconDirectionDesc', 'iconDirectionAsc']);
/* harmony default export */ var TableSortLabel_tableSortLabelClasses = (tableSortLabelClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableSortLabel/TableSortLabel.js


const TableSortLabel_excluded = ["active", "children", "className", "direction", "hideSortIcon", "IconComponent"];












const useUtilityClasses = ownerState => {
  const {
    classes,
    direction,
    active
  } = ownerState;
  const slots = {
    root: ['root', active && 'active'],
    icon: ['icon', `iconDirection${(0,utils_capitalize/* default */.Z)(direction)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getTableSortLabelUtilityClass, classes);
};
const TableSortLabelRoot = (0,styled/* default */.ZP)(ButtonBase/* default */.Z, {
  name: 'MuiTableSortLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.active && styles.active];
  }
})(({
  theme
}) => ({
  cursor: 'pointer',
  display: 'inline-flex',
  justifyContent: 'flex-start',
  flexDirection: 'inherit',
  alignItems: 'center',
  '&:focus': {
    color: (theme.vars || theme).palette.text.secondary
  },
  '&:hover': {
    color: (theme.vars || theme).palette.text.secondary,
    [`& .${TableSortLabel_tableSortLabelClasses.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${TableSortLabel_tableSortLabelClasses.active}`]: {
    color: (theme.vars || theme).palette.text.primary,
    [`& .${TableSortLabel_tableSortLabelClasses.icon}`]: {
      opacity: 1,
      color: (theme.vars || theme).palette.text.secondary
    }
  }
}));
const TableSortLabelIcon = (0,styled/* default */.ZP)('span', {
  name: 'MuiTableSortLabel',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, styles[`iconDirection${(0,utils_capitalize/* default */.Z)(ownerState.direction)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: theme.transitions.create(['opacity', 'transform'], {
    duration: theme.transitions.duration.shorter
  }),
  userSelect: 'none'
}, ownerState.direction === 'desc' && {
  transform: 'rotate(0deg)'
}, ownerState.direction === 'asc' && {
  transform: 'rotate(180deg)'
}));

/**
 * A button based label for placing inside `TableCell` for column sorting.
 */
const TableSortLabel = /*#__PURE__*/react.forwardRef(function TableSortLabel(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTableSortLabel'
  });
  const {
      active = false,
      children,
      className,
      direction = 'asc',
      hideSortIcon = false,
      IconComponent = ArrowDownward
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, TableSortLabel_excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    active,
    direction,
    hideSortIcon,
    IconComponent
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TableSortLabelRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    component: "span",
    disableRipple: true,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [children, hideSortIcon && !active ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(TableSortLabelIcon, {
      as: IconComponent,
      className: (0,clsx_m/* default */.Z)(classes.icon),
      ownerState: ownerState
    })]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var TableSortLabel_TableSortLabel = (TableSortLabel);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(53252);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableContainer/TableContainer.js + 1 modules
var TableContainer = __webpack_require__(72882);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableFooter/TableFooter.js + 1 modules
var TableFooter = __webpack_require__(24661);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(53184);
// EXTERNAL MODULE: ./node_modules/@mui/material/TablePagination/TablePagination.js + 6 modules
var TablePagination = __webpack_require__(8896);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(68509);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/contacts/GMClientTable.tsx





function GMClientTable_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function GMClientTable_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GMClientTable_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GMClientTable_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var columns = [{
  id: "name",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Name"),
  subtitle:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Email Address"),
  minWidth: 170,
  sortField: api/* ClientSortField.Client */._gK.Client,
  renderer: function renderer(item) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: item.person.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-xs text-gray-800",
        children: item.person.email
      })]
    });
  }
}, {
  id: "person.dateOfBirth",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("DOB"),
  minWidth: 100,
  sortField: api/* ClientSortField.Dob */._gK.Dob,
  renderer: function renderer(item) {
    if (item.person.dateOfBirth) {
      return moment_default()(item.person.dateOfBirth).format("LL");
    }

    return "-";
  }
}, {
  id: "person.mobileContact",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Number"),
  minWidth: 170,
  align: "left"
}, {
  id: "tags",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Tags"),
  minWidth: 170,
  align: "left",
  renderer: function renderer(item) {
    if (!item.tags) {
      return null;
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
      direction: "row",
      children: item.tags.filter(function (t) {
        return !!t;
      }).slice(0, 1).map(function (t) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Chip/* default */.Z, {
          color: "primary",
          variant: "outlined",
          label: (t === null || t === void 0 ? void 0 : t.title) || "",
          className: "text-gray-900"
        }, (t === null || t === void 0 ? void 0 : t.id) || "");
      })
    });
  }
}];

var GMClientTable = function GMClientTable(_ref) {
  var _data$clients, _data$clients$edges, _data$clients2, _displayClients$slice;

  var onSelectedChange = _ref.onSelectedChange,
      initialSelectedIds = _ref.selectedIds,
      _ref$idIdentity = _ref.idIdentity,
      idIdentity = _ref$idIdentity === void 0 ? "id" : _ref$idIdentity,
      emptyMessage = _ref.emptyMessage,
      selectedClients = _ref.selectedClients,
      filter = _ref.filter;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      page = _React$useState2[0],
      setPage = _React$useState2[1];

  var _React$useState3 = react.useState(initialSelectedIds || []),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      selected = _React$useState4[0],
      setSelected = _React$useState4[1];

  var _useState = (0,react.useState)(10),
      rowsPerPage = _useState[0],
      setRowsPerPage = _useState[1];

  var _useState2 = (0,react.useState)({
    field: api/* ClientSortField.Client */._gK.Client,
    direction: api/* OrderDirection.Asc */.N9t.Asc
  }),
      sortInput = _useState2[0],
      setSortInput = _useState2[1];

  var _useState3 = (0,react.useState)({
    filter: filter,
    first: rowsPerPage,
    sortBy: sortInput
  }),
      contactQuery = _useState3[0],
      setContactQuery = _useState3[1];

  var _useState4 = (0,react.useState)(0),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useGoalsmapperClient = (0,api/* useGoalsmapperClientsQuery */.jWL)({
    variables: contactQuery,
    fetchPolicy: "network-only"
  }),
      loading = _useGoalsmapperClient.loading,
      data = _useGoalsmapperClient.data,
      fetchMore = _useGoalsmapperClient.fetchMore;

  (0,react.useEffect)(function () {
    setContactQuery(function (query) {
      return GMClientTable_objectSpread(GMClientTable_objectSpread({}, query), {}, {
        first: rowsPerPage,
        filter: filter,
        sortBy: sortInput
      });
    });
    setCurrentPage(0);
  }, [filter, sortInput]);
  var clients = (data === null || data === void 0 ? void 0 : (_data$clients = data.clients) === null || _data$clients === void 0 ? void 0 : (_data$clients$edges = _data$clients.edges) === null || _data$clients$edges === void 0 ? void 0 : _data$clients$edges.map(function (edge) {
    return edge.node;
  })) || [];
  var totalCount = (data === null || data === void 0 ? void 0 : (_data$clients2 = data.clients) === null || _data$clients2 === void 0 ? void 0 : _data$clients2.totalCount) || 0;
  var isEmpty = totalCount === 0 && !loading;
  (0,react.useEffect)(function () {
    if (initialSelectedIds && initialSelectedIds.length > 0) {
      setSelected((0,toConsumableArray/* default */.Z)(initialSelectedIds));
    } else {
      setSelected([]);
    }
  }, [initialSelectedIds]);

  var handleChangePage = function handleChangePage(event, newPage) {
    if (newPage > currentPage) {
      var _data$clients3, _data$clients3$pageIn;

      fetchMore({
        variables: {
          after: data === null || data === void 0 ? void 0 : (_data$clients3 = data.clients) === null || _data$clients3 === void 0 ? void 0 : (_data$clients3$pageIn = _data$clients3.pageInfo) === null || _data$clients3$pageIn === void 0 ? void 0 : _data$clients3$pageIn.endCursor
        }
      });
    }

    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setContactQuery(function (query) {
      return GMClientTable_objectSpread(GMClientTable_objectSpread({}, query), {}, {
        first: +event.target.value
      });
    });
    setRowsPerPage(+event.target.value);
    setCurrentPage(0);
  };

  var isSelected = function isSelected(client) {
    if (idIdentity === "id") return selected.indexOf(client.id) !== -1;else return selected.indexOf(client.person.id) !== -1;
  };

  var getChangeId = function getChangeId(client) {
    if (idIdentity === "id") return client.id;else return client.person.id;
  };

  var handleSelectAllClick = function handleSelectAllClick(event) {
    if (event.target.checked) {
      var newSelecteds = clients.map(function (n) {
        return getChangeId(n);
      });
      setSelected(newSelecteds);
      onSelectedChange && onSelectedChange(newSelecteds, clients);
      return;
    }

    setSelected([]);
    onSelectedChange && onSelectedChange([], []);
  };

  var handleClick = function handleClick(event, client) {
    var changeId = getChangeId(client);
    var selectedIndex = selected.indexOf(changeId); //console.log(selectedIndex);

    var newSelected = [];
    var newSelectedClients = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, changeId);
      newSelectedClients = newSelectedClients.concat(selectedClients, client);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newSelectedClients = newSelectedClients.concat(selectedClients.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newSelectedClients = newSelectedClients.concat(selectedClients.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      newSelectedClients = newSelectedClients.concat(selectedClients.slice(0, selectedIndex), selectedClients.slice(selectedIndex + 1));
    }

    setSelected(newSelected); // const selectedClients = clients.filter((c) => newSelected.includes(get(c, idIdentity)));

    onSelectedChange && onSelectedChange(Array.from(newSelected), newSelectedClients);
  }; // const handleRemoveSelected = () => {};


  var createSortHandler = function createSortHandler(columnSortField) {
    return function (event) {
      if (columnSortField) {
        setSortInput(function (prevState) {
          var direction = api/* OrderDirection.Asc */.N9t.Asc;

          if (prevState.field === columnSortField) {
            direction = prevState.direction === api/* OrderDirection.Desc */.N9t.Desc ? api/* OrderDirection.Asc */.N9t.Asc : api/* OrderDirection.Desc */.N9t.Desc;
          }

          return {
            field: columnSortField,
            direction: direction
          };
        });
      }
    };
  };

  var numSelected = selected.length;
  var rowCount = clients === null || clients === void 0 ? void 0 : clients.length;
  var startIndex = currentPage * rowsPerPage;
  var displayClients = clients === null || clients === void 0 ? void 0 : clients.slice(startIndex, startIndex + rowsPerPage);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    pt: 2,
    minHeight: 200,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Table/* default */.Z, {
        stickyHeader: true,
        "aria-label": "sticky table",
        size: "small",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableHead/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
              padding: "checkbox",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                color: "primary",
                indeterminate: numSelected > 0 && numSelected < rowCount,
                checked: rowCount > 0 && numSelected === rowCount,
                onChange: handleSelectAllClick,
                inputProps: {
                  "aria-label": "select all recipients"
                }
              })
            }), columns.map(function (column) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                align: column.align,
                style: {
                  minWidth: column.minWidth
                },
                children: column.sortField ? /*#__PURE__*/(0,jsx_runtime.jsx)(TableSortLabel_TableSortLabel, {
                  active: sortInput.field === column.sortField,
                  direction: sortInput.field === column.sortField && sortInput.direction === api/* OrderDirection.Desc */.N9t.Desc ? "desc" : "asc",
                  onClick: createSortHandler(column.sortField),
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "column",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                      children: column.label
                    }), column.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "text-xs font-normal text-gray-600",
                      children: column.subtitle
                    })]
                  })
                }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                  direction: "column",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: column.label
                  }), column.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "text-xs font-normal text-gray-600",
                    children: column.subtitle
                  })]
                })
              }, column.id);
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
          children: [displayClients === null || displayClients === void 0 ? void 0 : (_displayClients$slice = displayClients.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)) === null || _displayClients$slice === void 0 ? void 0 : _displayClients$slice.map(function (client, index) {
            var isItemSelected = isSelected(client);
            var labelId = "enhanced-table-checkbox-".concat(index);
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
              hover: true,
              role: "checkbox",
              tabIndex: -1,
              selected: isItemSelected,
              onClick: function onClick(event) {
                return handleClick(event, client);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                padding: "checkbox",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                  color: "primary",
                  checked: isItemSelected,
                  inputProps: {
                    "aria-labelledby": labelId
                  }
                })
              }), columns.map(function (column) {
                var value = get_default()(client, column.id);
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                  align: column.align,
                  children: column.renderer ? column.renderer(client) : value
                }, column.id);
              })]
            }, client.id);
          }), !loading && rowCount === 0 && emptyMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(TableRow/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
              height: 400,
              colSpan: columns.length + 1,
              align: "center",
              children: emptyMessage
            })
          })]
        }), loading && /*#__PURE__*/(0,jsx_runtime.jsx)(TableFooter/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableRow/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
              height: 400,
              colSpan: 5,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "center",
                py: 2,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
              })
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TablePagination/* default */.Z, {
      rowsPerPageOptions: [10, 25, 100],
      component: "div",
      count: totalCount,
      rowsPerPage: rowsPerPage,
      page: currentPage,
      onPageChange: handleChangePage,
      onRowsPerPageChange: handleChangeRowsPerPage
    })]
  });
};

/* harmony default export */ var contacts_GMClientTable = (GMClientTable);
;// CONCATENATED MODULE: ./components/contacts/SelectClientDialog.tsx







function SelectClientDialog_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectClientDialog_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectClientDialog_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectClientDialog_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var SelectClientDialog = function SelectClientDialog(_ref) {
  var _checkoutData$userDra, _checkouts$0$lines$;

  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      initialClients = _ref.clients,
      onShopForClients = _ref.onShopForClients,
      selectedVariant = _ref.selectedVariant;

  var _useAuthState = (0,sdk_esm/* useAuthState */.F_)(),
      user = _useAuthState.user;

  var _useChannelContext = (0,ChannelContext/* default */.Z)(),
      channel = _useChannelContext.channel;

  var _useState = (0,react.useState)(initialClients ? {} : {}),
      filter = _useState[0],
      setFilter = _useState[1];

  var _useState2 = (0,react.useState)(initialClients || []),
      selectedClients = _useState2[0],
      setSelectedClients = _useState2[1];

  var _useCheckoutBulkCreat = (0,api/* useCheckoutBulkCreateMutation */.gj2)({
    refetchQueries: [{
      query: api/* UserDraftCheckoutsDocument */.MYw,
      variables: {
        first: 100,
        channel: channel,
        multipleCheckout: false
      }
    }],
    awaitRefetchQueries: true
  }),
      _useCheckoutBulkCreat2 = (0,slicedToArray/* default */.Z)(_useCheckoutBulkCreat, 2),
      bulkCreateCheckout = _useCheckoutBulkCreat2[0],
      bulkCreateProcessing = _useCheckoutBulkCreat2[1].loading;

  var _useUserDraftCheckout = (0,api/* useUserDraftCheckoutsQuery */.Pr_)({
    variables: {
      first: 100,
      channel: channel,
      multipleCheckout: false
    }
  }),
      checkoutData = _useUserDraftCheckout.data;

  var _useGoalsmapperClient = (0,api/* useGoalsmapperClientsQuery */.jWL)({
    variables: {
      filter: filter,
      first: 100,
      after: null
    }
  }),
      loading = _useGoalsmapperClient.loading,
      data = _useGoalsmapperClient.data,
      refetch = _useGoalsmapperClient.refetch;

  var checkouts = checkoutData === null || checkoutData === void 0 ? void 0 : (_checkoutData$userDra = checkoutData.userDraftCheckouts) === null || _checkoutData$userDra === void 0 ? void 0 : _checkoutData$userDra.edges.map(function (e) {
    return e.node;
  });

  if (!checkouts || !checkouts[0] || !checkouts[0].lines) {
    return null;
  }

  var variant = (_checkouts$0$lines$ = checkouts[0].lines[0]) === null || _checkouts$0$lines$ === void 0 ? void 0 : _checkouts$0$lines$.variant;
  var enoughStocks = true;
  var availableStock = 0;

  if (variant) {
    enoughStocks = ((variant === null || variant === void 0 ? void 0 : variant.quantityAvailable) || 0) >= selectedClients.length;
    availableStock = variant.quantityAvailable > 0 ? variant.quantityAvailable : 0;
  } else if (selectedVariant) {
    enoughStocks = selectedVariant.quantityAvailable >= selectedClients.length;
    availableStock = selectedVariant.quantityAvailable > 0 ? selectedVariant.quantityAvailable : 0;
  }

  var handleChange = function handleChange(event) {
    setFilter(SelectClientDialog_objectSpread(SelectClientDialog_objectSpread({}, filter), {}, {
      search: event.target.value
    }));
  };

  var handleStartSearch = function handleStartSearch() {
    setFilter({});
  };

  var onFilterChanged = function onFilterChanged(filterOps) {
    if (!filterOps) {
      setFilter({
        search: filter === null || filter === void 0 ? void 0 : filter.search
      });
    } else {
      var newFilter = {
        search: filter === null || filter === void 0 ? void 0 : filter.search,
        age: {
          gte: filterOps.startAge,
          lte: filterOps.endAge
        }
      };

      if (filterOps.maritalStatus) {
        newFilter.maritalStatus = filterOps.maritalStatus;
      }

      if (filterOps.birthday) {
        newFilter.dateOfBirth = filterOps.birthday;
      }

      if (filterOps.gender) {
        newFilter.gender = filterOps.gender;
      }

      setFilter(newFilter);
    }
  };

  var clonePreferences = function clonePreferences(checkout, profile) {
    var _checkout$lines$, _checkout$lines$$pref;

    if (!checkout) {
      return null;
    }

    if (!(checkout !== null && checkout !== void 0 && checkout.lines) || checkout.lines.length === 0) {
      return null;
    }

    return checkout === null || checkout === void 0 ? void 0 : (_checkout$lines$ = checkout.lines[0]) === null || _checkout$lines$ === void 0 ? void 0 : (_checkout$lines$$pref = _checkout$lines$.preferences) === null || _checkout$lines$$pref === void 0 ? void 0 : _checkout$lines$$pref.filter(function (p) {
      return !!p && p.attribute;
    }).map(function (pref) {
      return {
        attributeId: pref.attribute.id,
        preferenceValue: (0,utils/* normalizePreferenceValue */.zO)(pref.attribute, pref === null || pref === void 0 ? void 0 : pref.value, profile || (checkout === null || checkout === void 0 ? void 0 : checkout.profile), user) || ""
      };
    });
  };

  var prepareLinesVariable = function prepareLinesVariable() {
    if (!variant) {
      return selectedClients.map(function (client) {
        return {
          profileId: client.person.id,
          checkoutLines: [],
          shipToAdvisor: false
        };
      });
    }

    var checkoutMap = checkouts.reduce(function (a, c) {
      if (c.profile) {
        a[c.profile.id] = c;
      }

      return a;
    }, {}) || {};
    return selectedClients.map(function (client) {
      var currentCheckout = checkoutMap[client.person.id];
      return {
        profileId: client.person.id,
        checkoutLines: [{
          quantity: 1,
          variantId: variant.id,
          preferences: currentCheckout ? clonePreferences(currentCheckout) : clonePreferences(checkouts[0], client.person)
        }],
        shipToAdvisor: (currentCheckout === null || currentCheckout === void 0 ? void 0 : currentCheckout.shipToAdvisor) || false
      };
    });
  };

  var handleCreateList = function handleCreateList() {
    var _checkoutData$userDra2;

    if (bulkCreateProcessing) {
      return;
    }

    var firstCheckout = checkoutData === null || checkoutData === void 0 ? void 0 : (_checkoutData$userDra2 = checkoutData.userDraftCheckouts) === null || _checkoutData$userDra2 === void 0 ? void 0 : _checkoutData$userDra2.edges[0].node;
    var selectedDeliveryDate = firstCheckout === null || firstCheckout === void 0 ? void 0 : firstCheckout.selectedDeliveryDate;
    var initialProfileIds = (initialClients === null || initialClients === void 0 ? void 0 : initialClients.map(function (c) {
      return c.person.id;
    })) || [];
    var selectedProfileIds = selectedClients.map(function (c) {
      return c.person.id;
    });

    if (!firstCheckout || isEqual_default()(initialProfileIds === null || initialProfileIds === void 0 ? void 0 : initialProfileIds.sort(), selectedProfileIds.sort())) {
      onShopForClients && onShopForClients();
      return;
    }

    var lines = prepareLinesVariable();
    var billingAddress = firstCheckout.billingAddress;
    return bulkCreateCheckout({
      variables: {
        channel: channel,
        profileIds: selectedProfileIds,
        lines: lines,
        billingAddress: (0,address/* cloneAddress */.K)(billingAddress),
        selectedDeliveryDate: selectedDeliveryDate
      }
    }).then(function (response) {
      onShopForClients && onShopForClients();
    });
  };

  var onCancel = function onCancel() {
    setSelectedClients([]);
    onClose && onClose();
  };

  var renderActions = function renderActions() {
    if (!filter) {
      return null;
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
      direction: "row",
      justifyContent: "flex-end",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        className: "ml-6",
        variant: "outlined",
        onClick: onCancel,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
          id: "Cancel"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        disabled: !enoughStocks || bulkCreateProcessing || selectedClients.length === 0,
        variant: "contained",
        color: "primary",
        className: "ml-6",
        onClick: handleCreateList,
        endIcon: bulkCreateProcessing && /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
          size: 20
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
          id: "Done"
        })
      })]
    });
  };

  var onCreateContactCompleted = function onCreateContactCompleted() {
    refetch();
  };

  var renderClients = function renderClients() {
    if (!filter) {
      return null;
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(contacts_GMClientTable, {
      onSelectedChange: function onSelectedChange(clientIds, clients) {
        return setSelectedClients(clients);
      },
      selectedIds: selectedClients.map(function (c) {
        return c.person.id;
      }),
      idIdentity: "person.id",
      emptyMessage:
      /*i18n*/
      build_esm/* i18n._ */.ag._("You don't have any contacts! Please use Create Contact button above to add new."),
      selectedClients: selectedClients,
      filter: filter
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(GenericDialog/* default */.Z, {
    isOpen: isOpen,
    onClose: onClose,
    maxWidth: "md",
    title:
    /*i18n*/
    build_esm/* i18n._ */.ag._("Select Recipients to Shop for"),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      maxWidth: "md",
      disableGutters: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        className: "w-full",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
          direction: "row",
          spacing: 1,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
            id: "input-with-icon-adornment",
            className: "flex-1",
            startAdornment: /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
              position: "start",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Search/* default */.Z, {})
            }),
            endAdornment: /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
              position: "end",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(contacts_ClientFilterButton, {
                onFilterChanged: onFilterChanged
              })
            }),
            placeholder:
            /*i18n*/
            build_esm/* i18n._ */.ag._("Search by Contact\u2019s Name, Contact Number or Email"),
            value: filter === null || filter === void 0 ? void 0 : filter.search,
            onChange: handleChange
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateContactButton/* default */.Z, {
            onCompleted: onCreateContactCompleted
          })]
        }), !filter && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          variant: "contained",
          color: "primary",
          fullWidth: false,
          className: "mt-4",
          onClick: handleStartSearch,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
            id: "Search for Clients"
          })
        }), renderClients(), !enoughStocks && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
          className: "col-span-3 text-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
            spacing: 2,
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-s font-semibold text-red-700",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                  id: "There are only {availableStock} items of the product in Stock.",
                  values: {
                    availableStock: availableStock
                  }
                })
              })
            })
          })
        }), renderActions()]
      })
    })
  });
};

/* harmony default export */ var contacts_SelectClientDialog = (SelectClientDialog);

/***/ }),

/***/ 64587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ contacts_SelectedClientsDialog; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@lingui/react/build/esm/index.js
var esm = __webpack_require__(14744);
// EXTERNAL MODULE: ./node_modules/@lingui/core/build/esm/index.js + 1 modules
var build_esm = __webpack_require__(32601);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Delete.js
var Delete = __webpack_require__(41733);
// EXTERNAL MODULE: ./node_modules/@saleor/sdk/dist/sdk.esm.js + 1 modules
var sdk_esm = __webpack_require__(21637);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(9335);
// EXTERNAL MODULE: ./components/utils/address.ts
var address = __webpack_require__(76413);
// EXTERNAL MODULE: ./saleor/api.tsx + 2 modules
var api = __webpack_require__(39259);
// EXTERNAL MODULE: ./components/shared/contexts/ChannelContext.tsx + 2 modules
var ChannelContext = __webpack_require__(59247);
// EXTERNAL MODULE: ./components/shared/dialog/GenericDialog.tsx
var GenericDialog = __webpack_require__(54166);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AddCircle.js
var AddCircle = __webpack_require__(63205);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
// EXTERNAL MODULE: ./components/contacts/SelectClientDialog.tsx + 6 modules
var SelectClientDialog = __webpack_require__(6494);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/contacts/AddCheckoutClientButton.tsx











var AddCheckoutClientButton = function AddCheckoutClientButton(_ref) {
  var clients = _ref.clients,
      onClose = _ref.onClose,
      selectedVariant = _ref.selectedVariant;

  var _useToggle = (0,useToggle/* default */.Z)(false),
      _useToggle2 = (0,slicedToArray/* default */.Z)(_useToggle, 2),
      isSelectOpen = _useToggle2[0],
      toggleSelectDialog = _useToggle2[1];

  var handleClose = function handleClose() {
    toggleSelectDialog();
    onClose && onClose();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      size: "small",
      color: "primary",
      onClick: toggleSelectDialog,
      startIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(AddCircle/* default */.Z, {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
        id: "Add new Recipient(s)"
      })
    }), isSelectOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(SelectClientDialog/* default */.Z, {
      clients: clients,
      isOpen: isSelectOpen,
      onClose: handleClose,
      onShopForClients: handleClose,
      selectedVariant: selectedVariant
    })]
  });
};

/* harmony default export */ var contacts_AddCheckoutClientButton = (AddCheckoutClientButton);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(53252);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableContainer/TableContainer.js + 1 modules
var TableContainer = __webpack_require__(72882);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableFooter/TableFooter.js + 1 modules
var TableFooter = __webpack_require__(24661);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(53184);
// EXTERNAL MODULE: ./node_modules/@mui/material/TablePagination/TablePagination.js + 6 modules
var TablePagination = __webpack_require__(8896);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(68509);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/contacts/ClientTable.tsx





















var columns = [{
  id: "name",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Name"),
  subtitle:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Email Address"),
  minWidth: 170,
  renderer: function renderer(item) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: item.person.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-xs text-gray-800",
        children: item.person.email
      })]
    });
  }
}, {
  id: "person.dateOfBirth",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("DOB"),
  minWidth: 100,
  renderer: function renderer(item) {
    if (item.person.dateOfBirth) {
      return moment_default()(item.person.dateOfBirth).format("LL");
    }

    return "-";
  }
}, {
  id: "person.mobileContact",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Number"),
  minWidth: 170,
  align: "left"
}, {
  id: "tags",
  label:
  /*i18n*/
  build_esm/* i18n._ */.ag._("Tags"),
  minWidth: 170,
  align: "left",
  renderer: function renderer(item) {
    if (!item.tags) {
      return null;
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
      direction: "row",
      children: item.tags.filter(function (t) {
        return !!t;
      }).slice(0, 1).map(function (t) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Chip/* default */.Z, {
          color: "primary",
          variant: "outlined",
          label: (t === null || t === void 0 ? void 0 : t.title) || "",
          className: "text-gray-900"
        }, (t === null || t === void 0 ? void 0 : t.id) || "");
      })
    });
  }
}];

var ClientTable = function ClientTable(_ref) {
  var _clients$slice;

  var clients = _ref.clients,
      onSelectedChange = _ref.onSelectedChange,
      initialSelectedIds = _ref.selectedIds,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$idIdentity = _ref.idIdentity,
      idIdentity = _ref$idIdentity === void 0 ? "id" : _ref$idIdentity,
      emptyMessage = _ref.emptyMessage,
      selectedClients = _ref.selectedClients;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      page = _React$useState2[0],
      setPage = _React$useState2[1];

  var _React$useState3 = react.useState(10),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      rowsPerPage = _React$useState4[0],
      setRowsPerPage = _React$useState4[1];

  var _React$useState5 = react.useState(initialSelectedIds || []),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      selected = _React$useState6[0],
      setSelected = _React$useState6[1];

  (0,react.useEffect)(function () {
    if (initialSelectedIds && initialSelectedIds.length > 0) {
      setSelected((0,toConsumableArray/* default */.Z)(initialSelectedIds));
    } else {
      setSelected([]);
    }
  }, [initialSelectedIds]);

  var handleChangePage = function handleChangePage(event, newPage) {
    setPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  var isSelected = function isSelected(client) {
    // selected.indexOf(get(client, idIdentity)) !== -1;
    if (idIdentity === "id") return selected.indexOf(client.id) !== -1;else return selected.indexOf(client.person.id) !== -1;
  };

  var getChangeId = function getChangeId(client) {
    if (idIdentity === "id") return client.id;else return client.person.id;
  };

  var handleSelectAllClick = function handleSelectAllClick(event) {
    if (event.target.checked) {
      var newSelecteds = clients.map(function (n) {
        return getChangeId(n);
      });
      setSelected(newSelecteds);
      onSelectedChange && onSelectedChange(newSelecteds, clients);
      return;
    }

    setSelected([]);
    onSelectedChange && onSelectedChange([], []);
  };

  var handleClick = function handleClick(event, client) {
    var changeId = getChangeId(client);
    var selectedIndex = selected.indexOf(changeId); //console.log(selectedIndex);

    var newSelected = [];
    var newSelectedClients = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, changeId);
      newSelectedClients = newSelectedClients.concat(selectedClients, client);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newSelectedClients = newSelectedClients.concat(selectedClients.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newSelectedClients = newSelectedClients.concat(selectedClients.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      newSelectedClients = newSelectedClients.concat(selectedClients.slice(0, selectedIndex), selectedClients.slice(selectedIndex + 1));
    }

    setSelected(newSelected); // const selectedClients = clients.filter((c) => newSelected.includes(get(c, idIdentity)));

    onSelectedChange && onSelectedChange(Array.from(newSelected), newSelectedClients);
  }; // const handleRemoveSelected = () => {};


  var numSelected = selected.length;
  var rowCount = clients === null || clients === void 0 ? void 0 : clients.length;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
    pt: 2,
    minHeight: 200,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Table/* default */.Z, {
        stickyHeader: true,
        "aria-label": "sticky table",
        size: "small",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableHead/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
              padding: "checkbox",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                color: "primary",
                indeterminate: numSelected > 0 && numSelected < rowCount,
                checked: rowCount > 0 && numSelected === rowCount,
                onChange: handleSelectAllClick,
                inputProps: {
                  "aria-label": "select all desserts"
                }
              })
            }), columns.map(function (column) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                align: column.align,
                style: {
                  minWidth: column.minWidth
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
                  children: column.label
                }), column.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "text-xs font-normal text-gray-600",
                  children: column.subtitle
                })]
              }, column.id);
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
          children: [clients === null || clients === void 0 ? void 0 : (_clients$slice = clients.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)) === null || _clients$slice === void 0 ? void 0 : _clients$slice.map(function (client, index) {
            var isItemSelected = isSelected(client);
            var labelId = "enhanced-table-checkbox-".concat(index);
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
              hover: true,
              role: "checkbox",
              tabIndex: -1,
              selected: isItemSelected,
              onClick: function onClick(event) {
                return handleClick(event, client);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                padding: "checkbox",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                  color: "primary",
                  checked: isItemSelected,
                  inputProps: {
                    "aria-labelledby": labelId
                  }
                })
              }), columns.map(function (column) {
                var value = get_default()(client, column.id);
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                  align: column.align,
                  children: column.renderer ? column.renderer(client) : value
                }, column.id);
              })]
            }, client.id);
          }), rowCount === 0 && emptyMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(TableRow/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
              height: 100,
              colSpan: columns.length + 1,
              align: "center",
              children: emptyMessage
            })
          })]
        }), loading && /*#__PURE__*/(0,jsx_runtime.jsx)(TableFooter/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableRow/* default */.Z, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableCell/* default */.Z, {
              colSpan: 5,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "center",
                py: 2,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
              })
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TablePagination/* default */.Z, {
      rowsPerPageOptions: [10, 25, 100],
      component: "div",
      count: (clients === null || clients === void 0 ? void 0 : clients.length) || 0,
      rowsPerPage: rowsPerPage,
      page: page,
      onPageChange: handleChangePage,
      onRowsPerPageChange: handleChangeRowsPerPage
    })]
  });
};

/* harmony default export */ var contacts_ClientTable = (ClientTable);
;// CONCATENATED MODULE: ./components/contacts/SelectedClientsDialog.tsx






















var SelectedClientsDialog = function SelectedClientsDialog(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      clients = _ref.clients,
      onShopForClients = _ref.onShopForClients,
      selectedVariant = _ref.selectedVariant;

  var _useAuthState = (0,sdk_esm/* useAuthState */.F_)(),
      user = _useAuthState.user;

  var _useChannelContext = (0,ChannelContext/* default */.Z)(),
      channel = _useChannelContext.channel;

  var _useUserDraftCheckout = (0,api/* useUserDraftCheckoutsQuery */.Pr_)({
    variables: {
      first: 100,
      channel: channel,
      multipleCheckout: false
    }
  }),
      data = _useUserDraftCheckout.data,
      refetchCheckouts = _useUserDraftCheckout.refetch;

  var _useUserCheckoutDelet = (0,api/* useUserCheckoutDeleteMutation */.CHk)(),
      _useUserCheckoutDelet2 = (0,slicedToArray/* default */.Z)(_useUserCheckoutDelet, 1),
      userCheckoutDelete = _useUserCheckoutDelet2[0];

  var _useCreateCheckoutMut = (0,api/* useCreateCheckoutMutation */.F9n)({
    refetchQueries: [{
      query: api/* UserDraftCheckoutsDocument */.MYw,
      variables: {
        first: 100,
        channel: channel,
        multipleCheckout: false
      }
    }],
    awaitRefetchQueries: true
  }),
      _useCreateCheckoutMut2 = (0,slicedToArray/* default */.Z)(_useCreateCheckoutMut, 2),
      createCheckout = _useCreateCheckoutMut2[0],
      clearProcessing = _useCreateCheckoutMut2[1].loading;

  var _useCheckoutDeleteMut = (0,api/* useCheckoutDeleteMutation */.KKG)(),
      _useCheckoutDeleteMut2 = (0,slicedToArray/* default */.Z)(_useCheckoutDeleteMut, 1),
      deleteCheckout = _useCheckoutDeleteMut2[0];

  var snackbar = (0,hooks/* useSnackbar */.D)();

  var _useState = (0,react.useState)([]),
      selectedClients = _useState[0],
      setSelectedClients = _useState[1]; // const handleShopForClient = () => {
  //     onShopForClients && onShopForClients()
  // }


  var handleClearList = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _data$userDraftChecko;

      var checkouts, firstCheckout, checkoutLine, billingAddress, _checkoutLine$prefere, preferences;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              checkouts = data === null || data === void 0 ? void 0 : (_data$userDraftChecko = data.userDraftCheckouts) === null || _data$userDraftChecko === void 0 ? void 0 : _data$userDraftChecko.edges.map(function (e) {
                return e.node;
              });

              if (checkouts) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", null);

            case 3:
              firstCheckout = checkouts[0];
              checkoutLine = firstCheckout.lines ? firstCheckout.lines[0] : null;
              billingAddress = firstCheckout.billingAddress;

              if (!(checkoutLine && checkoutLine.variant)) {
                _context.next = 14;
                break;
              }

              _context.next = 9;
              return userCheckoutDelete();

            case 9:
              preferences = (_checkoutLine$prefere = checkoutLine.preferences) === null || _checkoutLine$prefere === void 0 ? void 0 : _checkoutLine$prefere.filter(function (p) {
                return !!p && !!p.attribute && !!p.value;
              }).map(function (pref) {
                return {
                  attributeId: pref.attribute.id,
                  preferenceValue: pref.value
                };
              });
              _context.next = 12;
              return createCheckout({
                variables: {
                  checkout: {
                    channel: channel,
                    email: (user === null || user === void 0 ? void 0 : user.email) || "anonymous@example.com",
                    lines: [{
                      quantity: 1,
                      variantId: checkoutLine.variant.id,
                      preferences: preferences
                    }],
                    billingAddress: (0,address/* cloneAddress */.K)(billingAddress),
                    selectedDeliveryDate: new Date()
                  }
                }
              });

            case 12:
              _context.next = 16;
              break;

            case 14:
              _context.next = 16;
              return userCheckoutDelete({
                refetchQueries: [{
                  query: api/* UserDraftCheckoutsDocument */.MYw,
                  variables: {
                    first: 100,
                    channel: channel,
                    multipleCheckout: false
                  }
                }],
                awaitRefetchQueries: true
              });

            case 16:
              onClose();
              snackbar.showSnackbar({
                message:
                /*i18n*/
                build_esm/* i18n._ */.ag._("Selected recipient(s) have been cleared"),
                severity: "success"
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClearList() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleRemoveSelected = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _data$userDraftChecko2;

      var totalCheckouts, _data$userDraftChecko3, tokenMap, tokens;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              totalCheckouts = (data === null || data === void 0 ? void 0 : (_data$userDraftChecko2 = data.userDraftCheckouts) === null || _data$userDraftChecko2 === void 0 ? void 0 : _data$userDraftChecko2.totalCount) || 0;

              if (!(selectedClients.length === totalCheckouts)) {
                _context2.next = 6;
                break;
              }

              _context2.next = 4;
              return userCheckoutDelete({
                refetchQueries: [{
                  query: api/* UserDraftCheckoutsDocument */.MYw,
                  variables: {
                    first: 100,
                    channel: channel,
                    multipleCheckout: false
                  },
                  fetchPolicy: "network-only"
                }],
                awaitRefetchQueries: true
              });

            case 4:
              _context2.next = 12;
              break;

            case 6:
              tokenMap = (data === null || data === void 0 ? void 0 : (_data$userDraftChecko3 = data.userDraftCheckouts) === null || _data$userDraftChecko3 === void 0 ? void 0 : _data$userDraftChecko3.edges.reduce(function (a, c) {
                var _c$node$profile;

                if ((_c$node$profile = c.node.profile) !== null && _c$node$profile !== void 0 && _c$node$profile.id) {
                  a[c.node.profile.id] = c.node.token;
                }

                return a;
              }, {})) || {};
              tokens = clients.map(function (client) {
                return selectedClients.includes(client.id) ? tokenMap[client.person.id] : null;
              }).filter(function (c) {
                return !!c;
              });
              _context2.next = 10;
              return Promise.all(tokens.map(function (token) {
                return deleteCheckout({
                  variables: {
                    token: token
                  }
                });
              }));

            case 10:
              _context2.next = 12;
              return refetchCheckouts({
                first: 100
              });

            case 12:
              snackbar.showSnackbar({
                message:
                /*i18n*/
                build_esm/* i18n._ */.ag._("Selected recipient(s) have been removed"),
                severity: "success"
              });
              setSelectedClients([]);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRemoveSelected() {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(GenericDialog/* default */.Z, {
    isOpen: isOpen,
    onClose: onClose,
    title:
    /*i18n*/
    build_esm/* i18n._ */.ag._("Selected Recipient(s)"),
    maxWidth: "lg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        justifyContent: "space-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          color: "error",
          size: "small",
          startIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(Delete/* default */.Z, {}),
          disabled: selectedClients.length === 0 || clearProcessing,
          onClick: handleRemoveSelected,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
            id: "remove-selected-clients",
            values: {
              "0": selectedClients.length
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(contacts_AddCheckoutClientButton, {
          clients: clients,
          selectedVariant: selectedVariant
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(contacts_ClientTable, {
        clients: clients,
        selectedIds: selectedClients,
        onSelectedChange: setSelectedClients,
        idIdentity: "person.id",
        selectedClients: clients
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        mt: 2,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          variant: "outlined",
          color: "primary",
          className: "ml-6",
          onClick: handleClearList,
          disabled: clearProcessing,
          endIcon: clearProcessing && /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
            size: 20
          }),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
            id: "Clear recipient list"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          variant: "contained",
          onClick: onClose,
          className: "ml-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
            id: "Done"
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var contacts_SelectedClientsDialog = (SelectedClientsDialog);

/***/ }),

/***/ 76916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ personalize_ProductPersonalize; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@lingui/react/build/esm/index.js
var esm = __webpack_require__(14744);
// EXTERNAL MODULE: ./node_modules/@lingui/core/build/esm/index.js + 1 modules
var build_esm = __webpack_require__(32601);
// EXTERNAL MODULE: ./node_modules/@saleor/sdk/dist/sdk.esm.js + 1 modules
var sdk_esm = __webpack_require__(21637);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./saleor/api.tsx + 2 modules
var api = __webpack_require__(39259);
// EXTERNAL MODULE: ./components/shared/contexts/ChannelContext.tsx + 2 modules
var ChannelContext = __webpack_require__(59247);
// EXTERNAL MODULE: ./components/shared/fields/index.tsx + 4 modules
var fields = __webpack_require__(93442);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(14564);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
// EXTERNAL MODULE: ./node_modules/material-ui-popup-state/es/index.js
var es = __webpack_require__(7586);
// EXTERNAL MODULE: ./components/personalize/constants.ts
var constants = __webpack_require__(79306);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/personalize/PersonalizeInfoPopover.tsx







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var PopoverButton = function PopoverButton() {
  var data = Object.keys(constants/* REPLACEMENT_MAP */.aV).map(function (key) {
    return {
      key: key,
      label: constants/* REPLACEMENT_MAP */.aV[key].label
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.ZP, {
    variant: "popover",
    popupId: "demo-popup-popover",
    children: function children(popupState) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, _objectSpread(_objectSpread({
          size: "small",
          color: "primary"
        }, (0,es/* bindTrigger */.vW)(popupState)), {}, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {})
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(Popover/* default */.ZP, _objectSpread(_objectSpread({}, (0,es/* bindPopover */.ZW)(popupState)), {}, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "center"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            px: 3,
            py: 3,
            spacing: 1,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
              direction: "row",
              spacing: 1,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                color: "primary"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "text-sm",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "font-semibold",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                    id: "Template Usage Guide"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                    id: "Use merge tags to insert personalized or dynamic content from your audience into the message."
                  })
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
              container: true,
              spacing: 1,
              pl: 3,
              className: "text-sm",
              children: data.map(function (item) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                  item: true,
                  xs: 6,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "font-semibold",
                      children: item.key
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      children: item.label
                    })]
                  })
                }, item.key);
              })
            })]
          })
        }))]
      });
    }
  });
};

/* harmony default export */ var PersonalizeInfoPopover = (PopoverButton);
;// CONCATENATED MODULE: ./components/personalize/PersonaliseField.tsx










var PersonaliseField = function PersonaliseField(_ref) {
  var attribute = _ref.attribute,
      name = _ref.name;

  switch (attribute.inputType) {
    case api/* AttributeInputTypeEnum.RichText */.ulP.RichText:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(fields/* InputField */.UP, {
        label: attribute.name || "",
        name: name,
        helpText: /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
          direction: "row",
          alignItems: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id: "e.g. Happy birthday!"
            }), " {{ full_name }}"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonalizeInfoPopover, {})]
        })
      });

    case api/* AttributeInputTypeEnum.Dropdown */.ulP.Dropdown:
      {
        var _attribute$choices, _attribute$choices$ed;

        var dropdownValues = ((_attribute$choices = attribute.choices) === null || _attribute$choices === void 0 ? void 0 : (_attribute$choices$ed = _attribute$choices.edges) === null || _attribute$choices$ed === void 0 ? void 0 : _attribute$choices$ed.map(function (_ref2) {
          var node = _ref2.node;
          return {
            label: node.name || "",
            value: node.name || node.id
          };
        })) || [];
        return /*#__PURE__*/(0,jsx_runtime.jsx)(fields/* DropdownField */.Hi, {
          label: attribute.name || "",
          data: dropdownValues,
          name: name,
          defaultText:
          /*i18n*/
          build_esm/* i18n._ */.ag._("Select...")
        });
      }

    case api/* AttributeInputTypeEnum.Numeric */.ulP.Numeric:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(fields/* InputField */.UP, {
        label: attribute.name || "",
        name: name,
        type: "number"
      });

    case api/* AttributeInputTypeEnum.Boolean */.ulP.Boolean:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(fields/* CheckboxGroupField */.cs, {
        label: attribute.name || "",
        name: name,
        data: {
          value: ""
        },
        direction: "row"
      });
  }

  return null;
};

/* harmony default export */ var personalize_PersonaliseField = (PersonaliseField);
// EXTERNAL MODULE: ./components/personalize/utils.ts
var utils = __webpack_require__(16825);
;// CONCATENATED MODULE: ./components/personalize/ProductPersonalize.tsx


















var ProductPersonalize = function ProductPersonalize(_ref) {
  var fieldPrefix = _ref.fieldPrefix,
      product = _ref.product,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      checkout = _ref.checkout,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "checkout" : _ref$variant;

  var _useChannelContext = (0,ChannelContext/* default */.Z)(),
      channel = _useChannelContext.channel;

  var _useUpdateCheckoutLin = (0,api/* useUpdateCheckoutLinePreferenceMutation */.wgx)({
    refetchQueries: [{
      query: api/* UserDraftCheckoutsDocument */.MYw,
      variables: {
        first: 100,
        channel: channel,
        multipleCheckout: false
      }
    }]
  }),
      _useUpdateCheckoutLin2 = (0,slicedToArray/* default */.Z)(_useUpdateCheckoutLin, 1),
      updateCheckoutLinePreference = _useUpdateCheckoutLin2[0];

  var _useCreateCheckoutLin = (0,api/* useCreateCheckoutLinePreferenceMutation */.MoY)({
    refetchQueries: [{
      query: api/* UserDraftCheckoutsDocument */.MYw,
      variables: {
        first: 100,
        channel: channel,
        multipleCheckout: false
      }
    }]
  }),
      _useCreateCheckoutLin2 = (0,slicedToArray/* default */.Z)(_useCreateCheckoutLin, 1),
      createCheckoutLinePreference = _useCreateCheckoutLin2[0];

  var _useAuthState = (0,sdk_esm/* useAuthState */.F_)(),
      user = _useAuthState.user;

  var _useFormikContext = (0,formik_esm/* useFormikContext */.u6)(),
      setFieldValue = _useFormikContext.setFieldValue;

  var savedPreferences = react.useMemo(function () {
    if (checkout !== null && checkout !== void 0 && checkout.lines && checkout.lines[0]) {
      var _checkoutLine$prefere;

      var _checkoutLine = checkout.lines[0];
      return ((_checkoutLine$prefere = _checkoutLine.preferences) === null || _checkoutLine$prefere === void 0 ? void 0 : _checkoutLine$prefere.reduce(function (a, c) {
        if (c !== null && c !== void 0 && c.attribute) {
          a[c.attribute.id] = c;
        }

        return a;
      }, {})) || {};
    }

    return {};
  }, [checkout === null || checkout === void 0 ? void 0 : checkout.lines]);
  var attributes = react.useMemo(function () {
    if (product) {
      return product.attributes;
    }

    if (checkout !== null && checkout !== void 0 && checkout.lines && checkout.lines[0]) {
      return checkout.lines[0].variant.product.attributes;
    }

    return [];
  }, [checkout === null || checkout === void 0 ? void 0 : checkout.lines, product]);
  var initialValues = react.useMemo(function () {
    return attributes.reduce(function (a, c) {
      if (c.attribute) {
        var _savedPreferences$c$a;

        a[c.attribute.id] = (_savedPreferences$c$a = savedPreferences[c.attribute.id]) === null || _savedPreferences$c$a === void 0 ? void 0 : _savedPreferences$c$a.value;
      }

      return a;
    }, {});
  }, [attributes, savedPreferences]);

  if (attributes.length === 0) {
    return null;
  }

  if (variant === "product") {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid grid-cols-4 gap-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-span-2 md:col-span-1 text-sm font-semibold pt-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
          id: "Personalise"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-span-4 md:col-span-3 border border-gray-300 rounded-md px-4 pt-3 pb-4 space-y-3",
        children: attributes.map(function (attribute) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(personalize_PersonaliseField, {
            attribute: attribute.attribute,
            name: fieldPrefix ? "".concat(fieldPrefix, ".").concat(attribute.attribute.id) : attribute.attribute.id || ""
          }, attribute.attribute.id);
        })
      })]
    });
  }

  if (!(checkout !== null && checkout !== void 0 && checkout.lines) || !checkout.lines[0]) {
    return null;
  }

  var checkoutLine = checkout.lines[0];

  var renderAttributeValue = function renderAttributeValue(attribute) {
    // const value = get(initialValues, attribute.id);
    var value = initialValues[attribute.id];

    switch (attribute.inputType) {
      case api/* AttributeInputTypeEnum.Dropdown */.ulP.Dropdown:
        {
          // const selected = attribute.choices?.edges.find((i) => i.node.id === value);
          // return selected?.node.name;
          return value;
        }

      case api/* AttributeInputTypeEnum.Boolean */.ulP.Boolean:
        return value ?
        /*i18n*/
        build_esm/* i18n._ */.ag._("Yes") :
        /*i18n*/
        build_esm/* i18n._ */.ag._("No");

      case api/* AttributeInputTypeEnum.RichText */.ulP.RichText:
        return (0,utils/* applyValueToCustomiseTemplate */.yl)(value, user, checkout.profile);

      default:
        return value;
    }
  };

  if (!active) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid grid-cols-4 gap-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-span-2 md:col-span-1 text-sm font-semibold pt-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
          id: "Personalise"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-span-4 md:col-span-3 border border-gray-300 rounded-md px-4 pt-3 pb-4 space-y-3",
        children: attributes.map(function (attribute) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 2,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-sm",
              style: {
                maxWidth: "40%"
              },
              children: attribute.attribute.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-sm font-semibold",
              children: renderAttributeValue(attribute.attribute)
            })]
          }, attribute.attribute.id);
        })
      })]
    });
  }

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values, helpers) {
      var res;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all(attributes.map(function (attribute) {
                var value = (0,utils/* normalizePreferenceValue */.zO)(attribute.attribute, values[attribute.attribute.id], checkout.profile, user) || "";

                if (savedPreferences[attribute.attribute.id]) {
                  return updateCheckoutLinePreference({
                    variables: {
                      preferenceId: savedPreferences[attribute.attribute.id].id,
                      value: value
                    }
                  });
                }

                return createCheckoutLinePreference({
                  variables: {
                    attributeId: attribute.attribute.id,
                    checkoutLineId: checkoutLine.id,
                    value: value
                  }
                });
              }));

            case 2:
              res = _context.sent;
              setFieldValue("activeCustomizationId", undefined);
              return _context.abrupt("return", res);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(); // const handleApplyToAll = () => {};


  var handleCancel = function handleCancel() {
    setFieldValue("activeCustomizationId", undefined);
  };

  var validateForm = function validateForm(values) {
    var errors = {};
    var validationMeta = (0,utils/* getAttributesValidationMeta */.z4)(attributes.map(function (c) {
      return c.attribute;
    }));
    attributes.forEach(function (_ref3) {
      var attribute = _ref3.attribute;
      var validationItem = validationMeta[attribute.id];

      if (validationItem) {
        if (validationItem.required && !values[attribute.id]) {
          errors[attribute.id] =
          /*i18n*/
          build_esm/* i18n._ */.ag._("Field is required");
        } else if (validationItem.maxLength) {
          var templateValue = (0,utils/* applyValueToCustomiseTemplate */.yl)(values[attribute.id], user, checkout.profile);

          if ((templateValue === null || templateValue === void 0 ? void 0 : templateValue.length) > validationItem.maxLength) {
            errors[attribute.id] =
            /*i18n*/
            build_esm/* i18n._ */.ag._("{0, plural, one {Field must be less than or equal to # character} other {Field must be less than or equal to # characters}}", {
              "0": validationItem.maxLength
            });
          }
        }
      }
    });
    return errors;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
    initialValues: initialValues,
    validate: validateForm,
    onSubmit: handleSubmit,
    validateOnMount: variant === "checkout",
    children: function children(_ref4) {
      var submitForm = _ref4.submitForm,
          isSubmitting = _ref4.isSubmitting;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "grid grid-cols-4 gap-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-span-2 md:col-span-1 text-sm font-semibold pt-2",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id: "Personalise"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-span-4 md:col-span-3 border border-gray-300 rounded-md px-4 pt-3 pb-4 space-y-3",
            children: attributes.map(function (attribute) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(personalize_PersonaliseField, {
                attribute: attribute.attribute,
                name: attribute.attribute.id
              }, attribute.attribute.id);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
          direction: "row",
          spacing: 2,
          mt: 2,
          justifyContent: "flex-end",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "outlined",
            onClick: handleCancel,
            disabled: isSubmitting,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id: "Cancel"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "contained",
            disabled: isSubmitting,
            onClick: submitForm,
            endIcon: isSubmitting && /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
              size: 20
            }),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id: "Save"
            })
          })]
        })]
      });
    }
  });
};

/* harmony default export */ var personalize_ProductPersonalize = (ProductPersonalize);

/***/ }),

/***/ 79306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oo": function() { return /* binding */ PRODUCT_ATTRIBUTE_VALIDATION_META; },
/* harmony export */   "aV": function() { return /* binding */ REPLACEMENT_MAP; },
/* harmony export */   "au": function() { return /* binding */ CUSTOM_DELIVERY_DATES_MOONCAKE_ATTR; },
/* harmony export */   "j3": function() { return /* binding */ CUSTOM_DELIVERY_DATES_META; }
/* harmony export */ });
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32601);

var REPLACEMENT_MAP = {
  "{{ name }}": {
    label:
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_0__/* .i18n._ */ .ag._("Preferred name of your client"),
    getter: "name"
  },
  "{{ full_name }}": {
    label:
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_0__/* .i18n._ */ .ag._("Name of your client"),
    getter: "fullName"
  },
  "{{ salutation }}": {
    label:
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_0__/* .i18n._ */ .ag._("Salutation of your client"),
    getter: "salutation"
  },
  "{{ sales_person_name }}": {
    label:
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_0__/* .i18n._ */ .ag._("Your name"),
    getter: function getter(client, user) {
      return "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.lastName).trim();
    }
  }
};
var PRODUCT_ATTRIBUTE_VALIDATION_META = {
  maxLength: {
    key: "max-length",
    name:
    /*i18n*/
    _lingui_core__WEBPACK_IMPORTED_MODULE_0__/* .i18n._ */ .ag._("Max length")
  }
};
var CUSTOM_DELIVERY_DATES_META = "custom-delivery-dates";
var CUSTOM_DELIVERY_DATES_MOONCAKE_ATTR = "mooncake-delivery-period";

/***/ }),

/***/ 16825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "yl": function() { return /* binding */ applyValueToCustomiseTemplate; },
/* harmony export */   "z4": function() { return /* binding */ getAttributesValidationMeta; },
/* harmony export */   "zO": function() { return /* binding */ normalizePreferenceValue; }
/* harmony export */ });
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _saleor_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39259);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79306);




var applyValueToCustomiseTemplate = function applyValueToCustomiseTemplate(value, user, profile) {
  var newValue = value;

  if (profile && value) {
    newValue = Object.keys(_constants__WEBPACK_IMPORTED_MODULE_3__/* .REPLACEMENT_MAP */ .aV).reduce(function (a, c) {
      var replacement = _constants__WEBPACK_IMPORTED_MODULE_3__/* .REPLACEMENT_MAP */ .aV[c];
      var replaceValue = typeof replacement.getter === "string" ? lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(profile, replacement.getter) : replacement.getter(profile, user);
      return a.replaceAll(c, replaceValue);
    }, value);
  }

  return newValue;
};
var normalizePreferenceValue = function normalizePreferenceValue(attribute, value, profile, user) {
  switch (attribute.inputType) {
    case _saleor_api__WEBPACK_IMPORTED_MODULE_2__/* .AttributeInputTypeEnum.RichText */ .ulP.RichText:
      if (user && value) {
        return applyValueToCustomiseTemplate(value, user, profile);
      }

      return value;

    default:
      return value;
  }
};
var getAttributesValidationMeta = function getAttributesValidationMeta(attributes) {
  return attributes.reduce(function (a, c) {
    var meta = {
      required: true
    };
    var maxLengthMeta = lodash_find__WEBPACK_IMPORTED_MODULE_0___default()(c.metadata, {
      key: _constants__WEBPACK_IMPORTED_MODULE_3__/* .PRODUCT_ATTRIBUTE_VALIDATION_META.maxLength.key */ .Oo.maxLength.key
    });

    if (maxLengthMeta) {
      meta.maxLength = Number(maxLengthMeta.value);
    }

    a[c.id] = meta;
    return a;
  }, {});
};

/***/ }),

/***/ 86908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94054);
/* harmony import */ var _mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33841);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2734);
/* harmony import */ var _mui_x_date_pickers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40328);
/* harmony import */ var _mui_x_date_pickers_DateTimePicker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99045);
/* harmony import */ var formik_mui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59266);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var _excluded = ["name", "id", "onChange", "value", "momentFormat", "label", "fullWidth", "required", "className", "helpText", "minDate", "maxDate", "disablePast", "disableFuture", "field", "form", "meta", "disableInput", "shouldDisableDate", "shouldDisableTime", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var DateField = function DateField(_ref) {
  var name = _ref.name,
      id = _ref.id,
      onChange = _ref.onChange,
      value = _ref.value,
      momentFormat = _ref.momentFormat,
      label = _ref.label,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      required = _ref.required,
      className = _ref.className,
      helpText = _ref.helpText,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      _ref$disablePast = _ref.disablePast,
      disablePast = _ref$disablePast === void 0 ? true : _ref$disablePast,
      _ref$disableFuture = _ref.disableFuture,
      disableFuture = _ref$disableFuture === void 0 ? false : _ref$disableFuture,
      field = _ref.field,
      form = _ref.form,
      meta = _ref.meta,
      disableInput = _ref.disableInput,
      shouldDisableDate = _ref.shouldDisableDate,
      shouldDisableTime = _ref.shouldDisableTime,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "date" : _ref$variant,
      others = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      selectedDate = _useState[0],
      setSelectedDate = _useState[1];

  var fieldMeta = form.getFieldMeta(field.name);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (value && variant === "date") {
      setSelectedDate(moment__WEBPACK_IMPORTED_MODULE_1___default()(value, momentFormat).startOf("day").toDate());
    } else if (value && variant === "datetime") {
      var datetime = moment__WEBPACK_IMPORTED_MODULE_1___default()(value, momentFormat).toDate(); //console.log("datetime", datetime);

      setSelectedDate(datetime);
    } else {
      setSelectedDate(null);
    }
  }, [value, momentFormat, variant]);

  var handleOnChange = function handleOnChange(value, KeyboardInputValue) {
    // if (value instanceof Date && !isNaN(value.getTime())) {
    setSelectedDate(value);

    if (variant === "date") {
      onChange && onChange(moment__WEBPACK_IMPORTED_MODULE_1___default()(value, momentFormat).startOf("day"));
    } else {
      onChange && onChange(moment__WEBPACK_IMPORTED_MODULE_1___default()(value, momentFormat));
    } // } else {
    // 	if (variant === "date") {
    // 		const dateValue = moment(KeyboardInputValue, momentFormat).startOf("day");
    // 		setSelectedDate(dateValue.toDate());
    // 		onChange && onChange(dateValue);
    // 	} else {
    // 		const dateTimeValue = moment(KeyboardInputValue, momentFormat);
    // 		setSelectedDate(dateTimeValue.toDate());
    // 		onChange && onChange(dateTimeValue);
    // 	}
    // }

  };

  var realId = id || name;

  var onKeyDown = function onKeyDown(event) {
    if (disableInput) {
      event.preventDefault();
    }
  };

  var renderPicker = function renderPicker() {
    if (variant === "date") {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_x_date_pickers__WEBPACK_IMPORTED_MODULE_6__/* .DatePicker */ .M, {
        onChange: handleOnChange,
        value: selectedDate,
        renderInput: function renderInput(params) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(formik_mui__WEBPACK_IMPORTED_MODULE_7__/* .TextField */ .n, _objectSpread(_objectSpread({}, params), {}, {
            field: field,
            form: form,
            meta: fieldMeta,
            onKeyDown: onKeyDown,
            FormHelperTextProps: {
              error: Boolean(fieldMeta.touched && fieldMeta.error && fieldMeta.error.length > 0),
              children: helpText
            },
            InputLabelProps: {
              error: Boolean(fieldMeta.touched && fieldMeta.error && fieldMeta.error.length > 0),
              children: helpText
            } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ,
            error: Boolean(fieldMeta.touched && fieldMeta.error && fieldMeta.error.length > 0),
            autoComplete: "off"
          }));
        },
        inputFormat: "dd-MMM-yyyy",
        disablePast: disablePast,
        disableFuture: disableFuture,
        minDate: minDate,
        maxDate: maxDate,
        mask: "",
        shouldDisableDate: shouldDisableDate,
        desktopModeMediaQuery: "@media (min-width: 320px)"
      });
    } else {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_x_date_pickers_DateTimePicker__WEBPACK_IMPORTED_MODULE_8__/* .DateTimePicker */ .x, {
        onChange: handleOnChange,
        value: selectedDate,
        renderInput: function renderInput(params) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(formik_mui__WEBPACK_IMPORTED_MODULE_7__/* .TextField */ .n, _objectSpread(_objectSpread({}, params), {}, {
            field: field,
            form: form,
            meta: fieldMeta,
            onKeyDown: onKeyDown,
            FormHelperTextProps: {
              error: Boolean(fieldMeta.touched && fieldMeta.error && fieldMeta.error.length > 0),
              children: helpText
            },
            InputLabelProps: {
              error: Boolean(fieldMeta.touched && fieldMeta.error && fieldMeta.error.length > 0),
              children: helpText
            } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ,
            error: Boolean(fieldMeta.touched && fieldMeta.error && fieldMeta.error.length > 0),
            autoComplete: "off" // InputProps={{
            // 	error: !meta?.error,
            // }}

          }));
        },
        inputFormat: "dd-MMM-yyyy hh:mm aaa",
        disablePast: disablePast,
        disableFuture: disableFuture,
        minDate: minDate,
        maxDate: maxDate,
        mask: "",
        shouldDisableDate: shouldDisableDate,
        shouldDisableTime: shouldDisableTime,
        ampm: false,
        views: ["year", "day", "hours"],
        desktopModeMediaQuery: "@media (min-width: 320px)"
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    fullWidth: fullWidth,
    variant: "standard",
    hiddenLabel: true,
    className: className,
    required: required // error={fieldMeta?.error !== undefined}s
    ,
    children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      style: {
        position: "unset",
        transform: "none"
      },
      disableAnimation: true,
      htmlFor: realId,
      className: "mb-1 text-sm font-semibold",
      children: label
    }), renderPicker()]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DateField);

/***/ }),

/***/ 22173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ DropdownField; }
/* harmony export */ });
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94054);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18972);
/* harmony import */ var _mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33841);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var formik_mui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14321);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var _excluded = ["className", "name", "label", "id", "helpText", "data", "defaultText", "fullWidth", "size", "renderItem", "required", "disabled", "defaultValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var DropdownField = function DropdownField(_ref) {
  var className = _ref.className,
      name = _ref.name,
      label = _ref.label,
      id = _ref.id,
      helpText = _ref.helpText,
      data = _ref.data,
      defaultText = _ref.defaultText,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "small" : _ref$size,
      renderItem = _ref.renderItem,
      required = _ref.required,
      disabled = _ref.disabled,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
      others = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var realId = id || name;

  var renderMenuItem = function renderMenuItem(item) {
    if (renderItem) {
      return renderItem(item);
    }

    return item.label || item.value;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    fullWidth: fullWidth,
    variant: "standard",
    className: className,
    required: required,
    disabled: disabled,
    children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      style: {
        position: "unset",
        transform: "none"
      },
      disableAnimation: true,
      htmlFor: realId,
      className: "mb-1 text-sm font-semibold",
      children: label
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, _objectSpread(_objectSpread({
      component: formik_mui__WEBPACK_IMPORTED_MODULE_7__/* .Select */ .P,
      formHelperText: helpText && {
        children: helpText
      },
      id: realId,
      name: name,
      labelId: "".concat(realId, "-label"),
      displayEmpty: !!defaultText,
      size: size,
      classes: {
        select: "h-6 pt-1 pb-3"
      },
      disabled: disabled
    }, others), {}, {
      children: [defaultText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        value: defaultValue,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          className: "text-gray-600",
          children: defaultText
        })
      }), data.map(function (item) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          value: item.value,
          children: renderMenuItem(item)
        }, "".concat(item.value));
      })]
    }))]
  });
};



/***/ }),

/***/ 93442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cs": function() { return /* reexport */ CheckboxGroupField; },
  "Hi": function() { return /* reexport */ DropdownField/* DropdownField */.H; },
  "UP": function() { return /* reexport */ InputField; },
  "G5": function() { return /* reexport */ PasswordInputField; }
});

// UNUSED EXPORTS: CheckboxField

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/shared/fields/CheckboxField.tsx



var _excluded = (/* unused pure expression or super */ null && (["className", "name", "label", "id", "helpText", "fullWidth", "required", "size"]));






var CheckboxField = function CheckboxField(_ref) {
  var className = _ref.className,
      name = _ref.name,
      label = _ref.label,
      id = _ref.id,
      helpText = _ref.helpText,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      required = _ref.required,
      size = _ref.size,
      others = _objectWithoutProperties(_ref, _excluded);

  var realId = id || name;
  return /*#__PURE__*/_jsxs(_FormControl, {
    fullWidth: fullWidth,
    variant: "standard",
    hiddenLabel: true,
    className: className,
    required: required,
    children: [label ? /*#__PURE__*/_jsx(Field, {
      id: realId,
      component: CheckboxWithLabel,
      type: "checkbox",
      name: name,
      Label: {
        label: label
      }
    }) : /*#__PURE__*/_jsx(Field, {
      id: realId,
      component: Checkbox,
      type: "checkbox",
      name: name
    }), helpText && /*#__PURE__*/_jsx(_FormHelperText, {
      id: "".concat(realId, "-helper-text"),
      children: helpText
    })]
  });
};


// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(56815);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox_Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/formik-mui/dist/esm/CheckboxWithLabel.js
var esm_CheckboxWithLabel = __webpack_require__(87635);
// EXTERNAL MODULE: ./node_modules/formik-mui/dist/esm/Checkbox.js
var esm_Checkbox = __webpack_require__(55362);
;// CONCATENATED MODULE: ./components/shared/fields/CheckboxGroupField.tsx








var CheckboxGroupField_excluded = ["direction", "data", "className", "name", "label", "id", "helpText", "fullWidth", "required"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var CheckboxGroupField = function CheckboxGroupField(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "column" : _ref$direction,
      data = _ref.data,
      className = _ref.className,
      name = _ref.name,
      label = _ref.label,
      id = _ref.id,
      helpText = _ref.helpText,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      required = _ref.required,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, CheckboxGroupField_excluded);

  var isMultiple = Array.isArray(data);
  var realId = id || name;

  var renderField = function renderField() {
    if (isMultiple) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* FieldArray */.F2, {
        name: name,
        render: function render(arrayHelpers) {
          var values = arrayHelpers.form.values[name] || [];

          var handleChange = function handleChange(item, checked) {
            return function (event) {
              if (event.target.checked) {
                if (!checked) {
                  arrayHelpers.push(item.value);
                }
              } else {
                if (checked) {
                  var index = values.findIndex(function (v) {
                    return v === item.value;
                  });

                  if (index >= 0) {
                    arrayHelpers.remove(index);
                  }
                }
              }
            };
          };

          return /*#__PURE__*/(0,jsx_runtime.jsx)(Stack/* default */.Z, {
            direction: "row",
            children: data.map(function (item, index) {
              var isChecked = values.includes(item.value);

              var control = /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox_Checkbox/* default */.Z, {
                checked: isChecked,
                value: isChecked,
                onChange: handleChange(item, isChecked)
              }, index);

              if (item.label) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                  control: control,
                  label: item.label
                }, index);
              }

              return control;
            })
          });
        }
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, _objectSpread({
      size: "small",
      type: "checkbox",
      Label: {
        label: data.label
      },
      id: realId,
      component: data.label ? esm_CheckboxWithLabel/* CheckboxWithLabel */.$ : esm_Checkbox/* Checkbox */.X,
      name: name,
      "aria-describedby": "".concat(realId, "-helper-text")
    }, others));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
    fullWidth: fullWidth,
    variant: "standard",
    hiddenLabel: true,
    className: className,
    required: required,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Stack/* default */.Z, {
      direction: direction,
      justifyContent: "space-between",
      children: [label && /*#__PURE__*/(0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
        style: {
          position: "unset",
          transform: "none"
        },
        disableAnimation: true,
        htmlFor: realId,
        className: "text-sm font-semibold",
        children: label
      }), renderField()]
    }), helpText && /*#__PURE__*/(0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
      id: "".concat(realId, "-helper-text"),
      children: helpText
    })]
  });
};


// EXTERNAL MODULE: ./components/shared/fields/DropdownField.tsx
var DropdownField = __webpack_require__(22173);
// EXTERNAL MODULE: ./node_modules/formik-mui/dist/esm/TextField.js
var TextField = __webpack_require__(59266);
;// CONCATENATED MODULE: ./components/shared/fields/InputField.tsx





var InputField_excluded = ["className", "name", "label", "id", "helpText", "fullWidth", "size", "required", "startAdornment", "endAdornment", "variant"];

function InputField_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InputField_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InputField_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InputField_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var InputField = function InputField(_ref) {
  var className = _ref.className,
      name = _ref.name,
      label = _ref.label,
      id = _ref.id,
      helpText = _ref.helpText,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "small" : _ref$size,
      required = _ref.required,
      startAdornment = _ref.startAdornment,
      endAdornment = _ref.endAdornment,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "outlined" : _ref$variant,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, InputField_excluded);

  var realId = id || name;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
    fullWidth: fullWidth,
    variant: "standard",
    hiddenLabel: true,
    className: className,
    required: required,
    children: [label && /*#__PURE__*/(0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
      style: {
        position: "unset",
        transform: "none"
      },
      disableAnimation: true,
      htmlFor: realId,
      className: "mb-1 text-sm font-semibold",
      children: label
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
      variant: variant,
      id: realId,
      component: TextField/* TextField */.n,
      name: name,
      InputProps: InputField_objectSpread({
        size: size,
        startAdornment: startAdornment,
        endAdornment: endAdornment,
        "aria-describedby": "".concat(realId, "-helper-text")
      }, others)
    }), helpText && /*#__PURE__*/(0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
      id: "".concat(realId, "-helper-text"),
      children: helpText
    })]
  });
};


// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Visibility.js
var Visibility = __webpack_require__(22961);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/VisibilityOff.js
var VisibilityOff = __webpack_require__(72450);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
;// CONCATENATED MODULE: ./components/shared/fields/PasswordInputField.tsx





function PasswordInputField_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PasswordInputField_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PasswordInputField_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PasswordInputField_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var PasswordInputField = function PasswordInputField(props) {
  var _useToggle = (0,useToggle/* default */.Z)(false),
      _useToggle2 = (0,slicedToArray/* default */.Z)(_useToggle, 2),
      isVisible = _useToggle2[0],
      toggleVisible = _useToggle2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(InputField, PasswordInputField_objectSpread(PasswordInputField_objectSpread({}, props), {}, {
    type: isVisible ? "text" : "password",
    endAdornment: /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
      position: "end",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        onClick: toggleVisible,
        size: "small",
        children: isVisible ? /*#__PURE__*/(0,jsx_runtime.jsx)(Visibility/* default */.Z, {
          style: {
            fontSize: 20
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {
          style: {
            fontSize: 20
          }
        })
      })
    })
  }));
};


;// CONCATENATED MODULE: ./components/shared/fields/index.tsx






/***/ }),

/***/ 9335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ hooks_useSnackbar; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/shared/contexts/SnackBarContext.ts
var SnackBarContext = __webpack_require__(11136);
;// CONCATENATED MODULE: ./components/shared/hooks/useSnackbar.ts



var useSnackbar = function useSnackbar() {
  return (0,react.useContext)(SnackBarContext/* default */.Z);
};

/* harmony default export */ var hooks_useSnackbar = (useSnackbar);
;// CONCATENATED MODULE: ./components/shared/hooks/index.ts


/***/ }),

/***/ 76413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ cloneAddress; }
/* harmony export */ });
/* harmony import */ var _saleor_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39259);

var cloneAddress = function cloneAddress(address) {
  var _address$country;

  if (!address) {
    return null;
  }

  return {
    firstName: (address === null || address === void 0 ? void 0 : address.firstName) || "",
    lastName: (address === null || address === void 0 ? void 0 : address.lastName) || "",
    phone: (address === null || address === void 0 ? void 0 : address.phone) || "",
    country: (address === null || address === void 0 ? void 0 : (_address$country = address.country) === null || _address$country === void 0 ? void 0 : _address$country.code) || _saleor_api__WEBPACK_IMPORTED_MODULE_0__/* .CountryCode.Sg */ .CvE.Sg,
    streetAddress1: (address === null || address === void 0 ? void 0 : address.streetAddress1) || "",
    streetAddress2: (address === null || address === void 0 ? void 0 : address.streetAddress2) || "",
    unitNumber: (address === null || address === void 0 ? void 0 : address.unitNumber) || "",
    city: (address === null || address === void 0 ? void 0 : address.city) || "",
    postalCode: (address === null || address === void 0 ? void 0 : address.postalCode) || ""
  };
};

/***/ }),

/***/ 28811:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 90116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(28811);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ })

}]);